import { createFileRoute } from "@tanstack/react-router";

import PasswordSetPage from "@/components/Password/PasswordSetPage";

export const Route = createFileRoute("/_auth/account/password/set")({
  component: PasswordSetPage,
});
